/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type OpenWebviewActionActionType =
  (typeof OpenWebviewActionActionType)[keyof typeof OpenWebviewActionActionType];

export const OpenWebviewActionActionType = {
  open_webview: 'open_webview',
} as const;
